const SET_MEDICINES = 'medicines//SET_MEDICINES'
const REMOVE_MEDICINES = 'medicines//REMOVE_MEDICINES'
const FILTER_MEDICINES = 'medicines//FILTER_MEDICINES'

export {
  SET_MEDICINES,
  REMOVE_MEDICINES,
  FILTER_MEDICINES
}
